/**
 * 投票：作答卡（进行中）与结果弹层（已结束）。
 *
 * 作答卡浮在内容区右下，不挡白板中央 —— 老师还在讲，投票不能盖住板书。
 */

import { useState } from 'react'

import { hasPerm, Perm } from '../lib/protocol'
import { useRoomStore } from '../stores/roomStore'

/** 进行中的投票卡。没有投票时不渲染。 */
export function PollCard() {
  const poll = useRoomStore((s) => s.poll)
  const stat = useRoomStore((s) => s.pollStat)
  const myVote = useRoomStore((s) => s.myVote)
  const submit = useRoomStore((s) => s.submitVote)
  const end = useRoomStore((s) => s.endPoll)
  const members = useRoomStore((s) => s.members)
  const selfId = useRoomStore((s) => s.selfId)
  const [picked, setPicked] = useState<number[]>([])
  const [folded, setFolded] = useState(false)

  if (!poll) return null
  const me = members.get(selfId)
  const isHost = !!me && hasPerm(me.prop, Perm.Op)
  const voted = myVote.length > 0
  const toggle = (i: number) =>
    setPicked((p) => (poll.multi ? (p.includes(i) ? p.filter((x) => x !== i) : [...p, i]) : [i]))

  if (folded) {
    return (
      <button className="poll-fold" onClick={() => setFolded(false)}>
        投票进行中{stat ? ` ${stat.voted}/${stat.total}` : ''}
      </button>
    )
  }

  return (
    <div className="poll-card" role="dialog" aria-label="投票">
      <div className="poll-head">
        <span className="poll-title">{poll.title}</span>
        <button className="poll-min" title="收起" onClick={() => setFolded(true)}>—</button>
      </div>
      <div className="poll-sub">
        {poll.multi ? '可多选' : '单选'}
        {poll.anonymous && ' · 匿名'}
        {stat && ` · 已投 ${stat.voted}/${stat.total}`}
      </div>

      <ul className="poll-opts">
        {poll.options.map((o) => {
          const c = stat?.counts.find((x) => x.index === o.index)
          const pct = stat && stat.voted > 0 && c ? Math.round((c.count / stat.voted) * 100) : 0
          return (
            <li key={o.index}>
              {voted ? (
                <div className="poll-res">
                  <span className="poll-res-txt">
                    {o.text}
                    {myVote.includes(o.index) && <em className="poll-mine">我选的</em>}
                  </span>
                  {/* 未开放实时统计时学员没有 stat，这里就只显示选项文字 */}
                  {stat && <span className="poll-res-num">{c?.count ?? 0} 票 · {pct}%</span>}
                  {stat && <span className="poll-bar" style={{ width: `${pct}%` }} />}
                </div>
              ) : (
                <label className="poll-pick">
                  <input
                    type={poll.multi ? 'checkbox' : 'radio'}
                    name="poll-opt"
                    checked={picked.includes(o.index)}
                    onChange={() => toggle(o.index)}
                  />
                  {o.text}
                </label>
              )}
            </li>
          )
        })}
      </ul>

      <div className="poll-foot">
        {!voted && (
          <button className="primary" disabled={picked.length === 0} onClick={() => submit(picked)}>
            提交
          </button>
        )}
        {voted && <span className="poll-done">已提交</span>}
        {isHost && <button className="poll-end" onClick={end}>结束投票</button>}
      </div>
    </div>
  )
}
